module.exports = __webpack_public_path__ + "static/media/LK__Phone.bff786e3.svg";